/**
 * Module-level handle to the app's TanStack Query client, so non-React code can
 * reach it without React context.
 *
 * The QueryClient is instantiated in App.tsx (it needs `ApiError` from the api
 * client for its retry predicate, and `api/client.ts` imports the auth store — so
 * importing the client back into the auth store would create a cycle). App
 * registers the instance here on startup; the auth store reads it imperatively to
 * purge cached PHI at an identity boundary (logout, or a mid-session nurse swap
 * via setAuth). Returns null only before registration — a window in which the
 * cache is empty anyway, so `getQueryClient()?.clear()` is a safe no-op.
 */
import type { QueryClient } from '@tanstack/react-query'

let client: QueryClient | null = null

/** Register the app's QueryClient. Called once from App on startup. */
export function registerQueryClient(queryClient: QueryClient): void {
  client = queryClient
}

/** The registered QueryClient, or null before registration. */
export function getQueryClient(): QueryClient | null {
  return client
}
